var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"monitor-arrematante flex col-grow no-wrap"},[_c('div',[_c('acessos')],1),_c('div',[_c('aprovacao')],1),_c('div',[_c('cadastros')],1),_c('div',[_c('origem-acesso')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }